import React from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import TextField from "@material-ui/core/TextField";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalCargando from "../../../components/Generales/ModalCargando"
import Globales from "utils/Globales";
import { InsertDriveFileRounded, GridOnRounded } from "@material-ui/icons";
import moment from 'moment';


class ReporteLibros extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      ListaIdiomas: [],
      ListaAux: [],
      FechaInicio: moment().format("YYYY-MM-DD"),
      FechaFin: moment().format("YYYY-MM-DD"),
      EstadoAlumno: "",
      OpcionPeriodo: "",
      //OpcionReportes: "",

      errorFechainicio: false,
      errorFechaFin: false,
      errorPeriodo: false,
      colorNotificacion: 'success',
      colorTableRow: "white",

      //Mensaje del cargando default
      CuerpoCargando: "Cargando"
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.entrar = true;
    this.handleChange = this.handleChange.bind(this);

  }

  componentDidMount() {
  }

  async GenererarReporteExpedientesCSV() {
    if (!this.validarFechas()) return

    this.setState({ cargando: true });
    const idVacio = { _increment: "0", _machine: "0", _pid: "0", _timestamp: "0" };

    await fetch(Globales.Url + 'Reportes/Reportes/GenerarReporteExcelToefl', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }, body: JSON.stringify({
        EstadoAlumnos: this.state.EstadoAlumno || null,
        FechaInicio: this.state.FechaInicio,
        FechaFin: this.state.FechaFin
      })
    }
    ).then(res => res.json())
      .then(data => {
        //console.log(data);
        if (data.error) { //Error en la respuesta
          this.setState({ mensaje: data.mensaje, colorNotificacion: "danger", Activo: 1, cargando: false });
          this.showNotification();
        } else { //Filtrado exitoso
          this.DescargarPDF(data.data, false);
        }
      })
      .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));;
  }

  async GenererarReporteExpedientesPDF() {
    if (!this.validarFechas()) return

    this.setState({ cargando: true });
    await fetch(Globales.Url + 'Reportes/Reportes/GenerarReporteToefl', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }, body: JSON.stringify({
        EstadoAlumnos: this.state.EstadoAlumno || null,
        FechaInicio: this.state.FechaInicio,
        FechaFin: this.state.FechaFin
      })
    }
    ).then(res => res.json())
      .then(data => {
        //console.log(data);
        if (data.error) { //Error en la respuesta
          this.setState({ mensaje: data.mensaje, colorNotificacion: "danger", Activo: 1, cargando: false });
          this.showNotification();
        } else { //Filtrado exitoso
          this.DescargarPDF(data.data, true);
        }
      })
      .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));;
  }

  DescargarPDF(archivoBase64, pdf = true) {
    let url = 'data:application/pdf;base64,' + archivoBase64;
    let nombre = 'Reporte de TOEFL'
    let fileName = `${nombre}.pdf`;

    if (!pdf) {
      var ArchivoUTF8 = atob(archivoBase64)
      var universalBOM = "\uFEFF";
      url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + ArchivoUTF8)
      fileName = `${nombre}.csv`;
    }

    const linkSource = `${url}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();

    this.setState({
      cargando: false,
      mensaje: "El archivo se generó exitosamente",
      colorNotificacion: "success",
    });
    this.showNotification();
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value, } = e.target;

    this.setState({ [name]: value });

  }

  validarFechas(int) {
    let valido = true;

    if (this.state.FechaFin < this.state.FechaInicio) {
      valido = false;
      this.setState({ errorFechainicio: false, errorFechaFin: true, mensaje: "La fecha final no puede ser antes de la fecha de inicio", colorNotificacion: "danger" });
      this.showNotification();
    } else {
      valido = true;
      this.setState({ errorFechainicio: false, errorFechaFin: false });
    }

    return valido
  }


  render() {
    let agregar;
    if (this.state.cargando == true) {
      agregar = (
        <ModalCargando
          Cuerpo={this.state.CuerpoCargando}
          show={this.state.cargando}
        />
      );
    }

    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4>Reporte de expedientes TOEFL</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <TextField fullWidth
                      variant="outlined" size="small"
                      type="date" format="DD-MM-YYYY"
                      label="Fecha inicio"
                      InputProps={{
                        onChange: this.handleChange.bind(this),
                        value: this.state.FechaInicio,
                        name: "FechaInicio",
                        id: "FechaInicio",
                        error: this.state.errorFechainicio,
                        success: !this.state.errorFechainicio
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <TextField fullWidth
                      variant="outlined" size="small"
                      type="date" format="DD-MM-YYYY"
                      label="Fecha fin"
                      InputProps={{
                        onChange: this.handleChange.bind(this),
                        value: this.state.FechaFin,
                        name: "FechaFin",
                        id: "FechaFin",
                        error: this.state.errorFechaFin,
                        success: !this.state.errorFechaFin
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl fullWidth size="small" variant="outlined">
                      <InputLabel id="Estado">Estado de los alumnos</InputLabel>
                      <Select
                        labelId="Estado"
                        value={this.state.EstadoAlumno}
                        onChange={this.handleChange.bind(this)}
                        name="EstadoAlumno"
                      >
                        <MenuItem value={""}>Todos</MenuItem>
                        <MenuItem value={"Activo"}>Activo</MenuItem>
                        <MenuItem value={"Inactivo"}>Inactivo</MenuItem>
                        <MenuItem value={"Aplicacion_TOEFL"}>Aplicación  TOEFL</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button size="sm" type="submit" color="info" round className="pull-right ml-3 mt-2" onClick={() => this.GenererarReporteExpedientesCSV()}><GridOnRounded />&nbsp;Exportar a excel</Button>
                    <Button size="sm" type="submit" color="info" round className="pull-right ml-3 mt-2" onClick={() => this.GenererarReporteExpedientesPDF()}><InsertDriveFileRounded />&nbsp;Exportar a PDF</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar grupo"}
            Cuerpo={"¿Está seguro que desea eliminar grupo?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(ReporteLibros);